/* M07 — Premium interactions: reveal, parallax, qty, lazy video */
(function(){
  'use strict';

  // Reveal on scroll
  const revealEls = document.querySelectorAll('.m07-reveal, .m07-mask');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-in'));
  }

  // Subtle parallax on hero media (transform only, GPU-friendly)
  const heroMedia = document.querySelector('[data-m07-parallax]');
  if (heroMedia && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const y = window.scrollY;
          if (y < window.innerHeight) {
            heroMedia.style.transform = `translate3d(0, ${y * 0.18}px, 0) scale(1.04)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Qty stepper
  document.querySelectorAll('.m07-qty-input').forEach(wrap => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty="-"]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.querySelector('[data-qty="+"]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Lazy video play on intersect (autoplay only when visible)
  if ('IntersectionObserver' in window) {
    const vio = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        const v = e.target;
        if (e.isIntersecting) {
          v.play().catch(()=>{ /* autoplay blocked, ok */ });
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('video[data-m07-autoplay]').forEach(v => vio.observe(v));
  }
})();
